<template>
  <div class="loading-screen">
    <v-progress-circular
      class="loading-indicator"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<style lang="scss" scoped>
.loading-indicator {
  display: block;
  margin: 5rem auto;
}
</style>

<script>
export default {
  name: "LoadingScreen"
};
</script>
